<template>
  <div>
    <c-list
      :data="cList.items"
      :columns="cList.columns"
      :total="cList.total"
      :page-size="1000"
      :page-current="listPageCurrent"
      :statistic="
        `总课时：${cList.totalClassHours}；已用课时：${
          cList.totalUsedClassHours
        }；剩余课时：${cList.totalClassHours -
          cList.totalUsedClassHours}；请假次数：${cList.totalLeaveCount}`
      "
      :search-where="listSearchWhere"
      @selection-change="handleListSelectionChange"
    >
      <c-list-header>
        <c-list-search>
          <Form
            class="c-form c-form--search"
            inline
            @submit.native.prevent="search"
          >
            <Form-item prop="signInDate">
              <c-date-range
                class="c-form__input"
                :value="cList.cSearch.where.signInDate.$eq"
                @change="
                  date => {
                    cList.cSearch.where.signInDate.$eq = date;
                  }
                "
              ></c-date-range>
            </Form-item>
            <Form-item prop="classId">
              <c-class-select
                class="c-form__input"
                @change="
                  value => {
                    cList.cSearch.where.classId.$eq = value;
                  }
                "
              >
              </c-class-select>
            </Form-item>
            <Form-item prop="studentId">
              <c-student-select
                class="c-form__input"
                @change="
                  value => {
                    cList.cSearch.where.studentId.$eq = value;
                  }
                "
              >
              </c-student-select>
            </Form-item>
            <Form-item>
              <Button type="primary" @click="search">
                查询
              </Button>
            </Form-item>
            <Form-item>
              <Button type="primary" @click="exportXlsx">
                导出
              </Button>
            </Form-item>
          </Form>
        </c-list-search>
      </c-list-header>
    </c-list>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import RouteParamsMixin from "view-ui-admin/src/mixins/route-params";
import ListMixin from "view-ui-admin/src/mixins/list";
import Model from "@/models/admin/courses";
import xlsx from "view-ui-admin/src/utils/xlsx";

const initWhere = {
  signInDate: {
    $eq: []
  },
  classId: {
    $eq: 0
  },
  studentId: {
    $eq: 0
  }
};

@Component({
  mixins: [RouteParamsMixin, ListMixin]
})
export default class extends Vue {
  data() {
    return {
      cList: {
        items: [],
        total: 0,
        totalClassHours: 0,
        totalUsedClassHours: 0,
        totalNormalCount: 0,
        totalLeaveCount: 0,
        totalLateCount: 0,
        columns: [
          {
            title: "班级",
            width: 150,
            render: (h, { row }) => h("span", null, row.className)
          },
          {
            title: "教师",
            width: 150,
            render: (h, { row }) => h("span", null, row.teacher.name)
          },
          {
            title: "学员",
            width: 150,
            render: (h, { row }) => h("span", null, row.student.name)
          },
          {
            title: "总费用",
            width: 100,
            render: (h, { row }) => h("span", null, row.student.classMoney)
          },
          {
            title: "单课程费用",
            width: 100,
            render: (h, { row }) =>
              h(
                "span",
                null,
                row.student.classHours > 0
                  ? row.student.classMoney / row.student.classHours
                  : 0
              )
          },
          {
            title: "剩余金额",
            width: 100,
            render: (h, { row }) =>
              h(
                "span",
                null,
                (row.student.classHours - row.student.usedClassHours) *
                  (row.student.classHours > 0
                    ? row.student.classMoney / row.student.classHours
                    : 0)
              )
          },
          {
            title: "已用金额",
            width: 100,
            render: (h, { row }) =>
              h(
                "span",
                null,
                row.student.usedClassHours *
                  (row.student.classHours > 0
                    ? row.student.classMoney / row.student.classHours
                    : 0)
              )
          },
          {
            title: "总课时",
            width: 100,
            render: (h, { row }) => h("span", null, row.student.classHours)
          },
          {
            title: "已用课时",
            width: 100,
            render: (h, { row }) => h("span", null, row.student.usedClassHours)
          },
          {
            title: "剩余课时",
            width: 100,
            render: (h, { row }) =>
              h(
                "span",
                null,
                row.student.classHours - row.student.usedClassHours
              )
          },
          {
            title: "请假次数",
            width: 100,
            render: (h, { row }) => h("span", null, row.student.leaveCount || 0)
          },
          {
            title: "点名时间",
            width: 180,
            render: (h, { row }) =>
              h("span", null, this.$time.getTime(row.student.updatedAt))
          }
        ],
        cSearch: {
          where: this.$helpers.deepCopy(initWhere)
        }
      }
    };
  }

  async beforeRouteUpdate(to, from, next) {
    this.initListSearchWhere(initWhere);
    this.getList();
    next();
  }

  async created() {
    this.initListSearchWhere(initWhere);
    this.getList();
  }

  async getList() {
    const {
      data: {
        items,
        total,
        totalClassHours,
        totalUsedClassHours,
        totalNormalCount,
        totalLeaveCount,
        totalLateCount
      }
    } = await new Model().addPath("statistics").POST({
      query: { where: this.listSearchWhere }
    });

    this.cList.items = items;
    this.cList.total = total;

    this.cList.totalClassHours = totalClassHours;
    this.cList.totalUsedClassHours = totalUsedClassHours;
    this.cList.totalNormalCount = totalNormalCount;
    this.cList.totalLeaveCount = totalLeaveCount;
    this.cList.totalLateCount = totalLateCount;
  }

  exportXlsx() {
    xlsx.download({
      fileName: `课消统计（${this.$time.getDate()}）`,
      data: (() => {
        return this.cList.items.map(item => {
          let ret = {};

          ret["班级"] = item.className;
          ret["教师"] = item.teacher.name;
          ret["学员"] = item.student.name;
          ret["总费用"] = item.student.classMoney;
          ret["单课程费用"] =
            item.student.classHours > 0
              ? item.student.classMoney / item.student.classHours
              : 0;
          ret["剩余金额"] =
            (item.student.classHours - item.student.usedClassHours) *
            (item.student.classHours > 0
              ? item.student.classMoney / item.student.classHours
              : 0);
          ret["已用金额"] =
            item.student.usedClassHours *
            (item.student.classHours > 0
              ? item.student.classMoney / item.student.classHours
              : 0);
          ret["总课时"] = item.student.classHours;
          ret["剩余课时"] =
            item.student.classHours - item.student.usedClassHours;
          ret["请假次数"] = item.student.leaveCount || 0;
          ret["点名时间"] = this.$time.getTime(item.student.updatedAt);

          return ret;
        });
      })()
    });
  }
}
</script>
